import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/Button";
import { useScrollToSection } from "@/hooks/useScrollToSection";
import { ArrowDown } from "lucide-react";
const scrollDownContent = {
  label: "Scroll Down"
};
export const ScrollDownButton = () => {
  const $ = _c(6);
  const {
    scrollToSection
  } = useScrollToSection();
  let t0;
  if ($[0] !== scrollToSection) {
    t0 = () => {
      scrollToSection("about-section");
    };
    $[0] = scrollToSection;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleScrollDown = t0;
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="body-small tracking-wider">{scrollDownContent.label}</span>;
    t2 = <ArrowDown className="w-5 h-5 text-(--color-foreground)" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handleScrollDown) {
    t3 = <Button onClick={handleScrollDown} variant="ghost" className="hidden! md:flex! flex-col! absolute! bottom-8 left-1/2 -translate-x-1/2 items-center gap-2 animate-bounce z-20 w-fit" aria-label="Scroll down">{t1}{t2}</Button>;
    $[4] = handleScrollDown;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};